import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Row } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIupdateFilesOrder } from '../../api/Collections';
import { swapFiles as swapFilesAction } from '../../actions/Files';

import FilesGridItem from './GridItem';

import { addFlashMessage } from '../../helpers/FlashMessages';
import withDragAndDropContext from '../../helpers/withDragAndDropContext';
import withFileSelection from '../../hoc/withFileSelection';

class FilesGrid extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      movedMenuItem: null,
    };

    this.moveFile = this.moveFile.bind(this);
    this.saveFiles = this.saveFiles.bind(this);
  }

  moveFile(dragIndex, hoverIndex) {
    const {
      swapFiles,
      reorderingMode,
    } = this.props;

    if (reorderingMode) {
      swapFiles(dragIndex, hoverIndex);
    }
  }

  saveFiles(dragIndex) {
    const {
      intl,
      collection,
      files,
      reorderingMode,
    } = this.props;

    if (!collection || !reorderingMode) {
      return;
    }

    this.setState({ movedMenuItem: dragIndex });
    const cfiles = files.map(f => (f.uuid));
    APIupdateFilesOrder(collection.uuid, cfiles).finally(() => {
      this.setState({ movedMenuItem: null });
    }).catch(() => {
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
      });
    });
  }

  render() {
    const {
      files,
      className,
      reorderingMode,
      selectedFiles,
      allowCheck,
      handleMoveSelectedItems,
    } = this.props;
    const { movedMenuItem } = this.state;

    return (
      <Row
        className={classnames(
          'gutter-20',
          'files-grid',
          className,
          { reordering: reorderingMode },
        )}
      >
        {files.map(f => (
          <FilesGridItem
            id={f.uuid}
            index={f.uuid}
            key={f.uuid}
            file={f}
            moveFile={this.moveFile}
            saveFiles={this.saveFiles}
            handleMoveSelectedItems={handleMoveSelectedItems}
            isMoved={movedMenuItem === f.uuid}
            isSelected={!!selectedFiles.find(sf => (sf.uuid === f.uuid))}
            {...this.props}
            allowCheck={typeof allowCheck === 'function' ? allowCheck(f) : allowCheck}
          />
        ))}
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  selectedFiles: state.Files.selectedFiles,
  reorderingMode: state.Files.reorderingMode,
});

const mapDispatchToProps = dispatch => ({
  swapFiles: (firstItem, secondItem) => {
    dispatch(swapFilesAction(firstItem, secondItem));
  },
});

FilesGrid.propTypes = {
  intl: PropTypes.object.isRequired,
  collection: PropTypes.object,
  selectedFiles: PropTypes.array.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
  files: PropTypes.array.isRequired,
  share: PropTypes.object,
  className: PropTypes.string,
  canDrag: PropTypes.bool,
  allowCheck: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  displayOnly: PropTypes.bool,
  swapFiles: PropTypes.func.isRequired,
  handleMoveSelectedItems: PropTypes.func,
  selectedView: PropTypes.string,
};

FilesGrid.defaultProps = {
  collection: null,
  share: null,
  className: '',
  canDrag: true,
  allowCheck: true,
  displayOnly: false,
  selectedView: null,
  handleMoveSelectedItems: () => {},
};

export default withDragAndDropContext(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(withFileSelection(FilesGrid))),
);
